const filterTypes = {
	DATA: "data",
	PERIODO: "periodo",
	TEXTO: 'texto',
	DOMINIO: "dominio",
	INTEIRO: "inteiro",
};

export default filterTypes;
